'use client'

import dynamic from 'next/dynamic'

// Disable SSR — reads Zustand auth store (persisted in localStorage)
// which is always empty on server, causing React 19 hydration mismatch
const RootRedirect = dynamic(
  () => import('./_root-redirect'),
  { ssr: false }
)

export default function Home() {
  return <RootRedirect />
}
